export function Formulas(client) {
    return {
        getAll(masterAccountId, uploadSetId, uploadFileId, dataframeId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataframeId}/formulas`);
        },
        applyFilteringFormula(masterAccountId, uploadSetId, uploadFileId, dataframeId, formulaPk, autoApply) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataframeId}/filtering`, {
                autoApply,
                formulaPk
            });
        },
        removeFilteringFormula(masterAccountId, uploadSetId, uploadFileId, dataframeId) {
            return client.delete(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataframeId}/filtering`);
        },
        applyTransformationFormula(masterAccountId, uploadSetId, uploadFileId, dataframeId, columnId, formulaPk, autoApply) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataframeId}/columns/${columnId}/transformation`, {
                autoApply,
                formulaPk
            });
        },
        removeTransformationFormula(masterAccountId, uploadSetId, uploadFileId, dataframeId, columnId) {
            return client.delete(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataframeId}/columns/${columnId}/transformation`);
        },
    };
}
